import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useCreateShopMutation, useGetShopCategoriesQuery } from "../../../features/shop/shopApiSlice";
import { publishImage } from "../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { FailedNotify, SuccessNotify } from "../../../constants/tostify";

export const useRetailerForm = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);

  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [gpsCoords, setGpsCoords] = useState({ latitude: null, longitude: null });

  // RTK Query hooks
  const { data: categoriesData } = useGetShopCategoriesQuery({
    type: "retailerShop",
    parentCategory: "",
  });

  const shopCategoryone = categoriesData?.data?.Category || [];

  const [createShopMutation, { isLoading: isCreating }] = useCreateShopMutation();

  // Fetch coordinates on mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setGpsCoords({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.warn("Shop GPS permission denied/failed:", error.message);
        }
      );
    }
  }, []);

  const [selectshop, setSelectshop] = useState({
    shopCategory: "",
  });

  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  useEffect(() => {
    if (categoryName) {
      localStorage.setItem("mycategory", categoryName);
    }
  }, [categoryName]);

  const [createShop, setCreateShop] = useState({
    userid: name?._id || "",
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [""],
    isFoodShop: false,
    shopCategory: "",
    businessType: "retailerShop",
    description: "",
    marketPlace: "",
    status: true,
    latitude: null,
    longitude: null,
  });

  useEffect(() => {
    setCreateShop((prev) => ({
      ...prev,
      shopCategory: categoryid || "",
    }));
  }, [categoryid]);

  useEffect(() => {
    if (gpsCoords.latitude && gpsCoords.longitude) {
      setCreateShop((prev) => ({
        ...prev,
        latitude: gpsCoords.latitude,
        longitude: gpsCoords.longitude,
      }));
    }
  }, [gpsCoords]);

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      setCreateShop((prev) => ({
        ...prev,
        image: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const PostShopData = async (e) => {
    e.preventDefault();

    try {
      const response = await createShopMutation(createShop).unwrap();
      SuccessNotify("Form Retailer Shop Created Successfully");
      const createdShopId =
        response?.data?._id || response?.data?.Shop?._id || response?._id;
      if (createdShopId) {
        navigate(`/rawmaterial-newitem/${createdShopId}`);
      }
    } catch (error) {
      console.error("Shop creation failed", error);
      const msg = error?.data?.message || "Failed To Create Shop";
      FailedNotify(msg);
    }
  };

  return {
    createShop,
    setCreateShop,
    shopCategoryone,
    isCreating,
    isUploading,
    uploadProgress,
    displayimg,
    setDisplayimg,
    Shopdatas,
    onDrop,
    PostShopData,
    getRootProps,
    getInputProps,
  };
};
